<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    <span class="treeTitleNum3" style="margin-left: 0" v-if="node.label.split('###')[3]=='X'">{{node.label.split('###')[0]}}</span>
                    <span v-else>{{node.label.split('###')[0]}}</span>
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card class="box-card" style="width: calc(100% - 344px); padding-top: 25px">
            <div class="tabBox">
                <div :class="'tabItem'+(search_type==1?' act':'')" @click="changeSearchType(1)">按孔查询</div>
                <div :class="'tabItem'+(search_type==2?' act':'')" @click="changeSearchType(2)">按报告查询</div>
            </div>
            <div class="mainBody">
                <div class="searchBox" v-if="list_model ==1">
                    <div class="searchGroup">
                        <label>孔号：</label>
                        <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==1">
                        <label>数据筛选：</label>
                        <el-select v-model="search_Obj.is_error" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option label="包含异常数据" value="1"></el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup" v-if="search_type==1">
                        <label>加深孔：</label>
                        <el-select v-model="search_Obj.f_is_deepen" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('yesNo')" :key="'deepen'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>段号：</label>
                        <el-input v-model="search_Obj.f_segment_no" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>处置结果：</label>
                        <el-select v-model="search_Obj.deal_result" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option label="数据正常" value="1"></el-option>
                            <el-option label="数据异常" value="2"></el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>开始时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="dateRangeSet1"
                            style="width:320px">
                        </el-date-picker>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>单位注灰量区间：</label>
                        <el-input v-model="search_Obj.ash_volume_unit_min" clearable :disabled="(search_Obj.permeable_rate_min!='' || search_Obj.permeable_rate_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.ash_volume_unit_max" clearable :disabled="(search_Obj.permeable_rate_min!='' || search_Obj.permeable_rate_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>透水率区间：</label>
                        <el-input v-model="search_Obj.permeable_rate_min" clearable :disabled="(search_Obj.ash_volume_unit_min!='' || search_Obj.ash_volume_unit_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.permeable_rate_max" clearable :disabled="(search_Obj.ash_volume_unit_min!='' || search_Obj.ash_volume_unit_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" v-if="search_type ==1 && grade==4"></Btns>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" :ignore_ids="',7102,7104,'" v-if="search_type==1 && grade>0 && grade<4"></Btns>
                </div>
                <div class="dataBox" v-if="list_model ==1 && search_type == 1">
                    <el-table :data="pagedData" :default-sort="sortData" :empty-text="empty_text" v-loading="loading" @sort-change="sortTable" border stripe>
                        <el-table-column prop="hole_code" label="孔号" sortable width="120"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume1" label="监测注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume_cha" label="差异值(L)"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume1" label="监测注灰量(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume_cha" label="差异值(Kg)"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate1" label="监测透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate_cha" label="差异值(Lu)"></el-table-column>
                        <el-table-column prop="pressure_cha_max" label="压力最大差值(Mpa)" v-if="(search_Obj.f_is_deepen=='')"></el-table-column>
                        <el-table-column prop="pressure_cha_min" label="压力最小差值(Mpa)" v-if="(search_Obj.f_is_deepen=='')"></el-table-column>
                        <el-table-column prop="density_cha_max" label="密度最大差值(g/cm3)" v-if="(search_Obj.f_is_deepen=='')"></el-table-column>
                        <el-table-column prop="density_cha_min" label="密度最小差值(g/cm3)" v-if="(search_Obj.f_is_deepen=='')"></el-table-column>
                        <el-table-column prop="deep" label="设计孔深" v-if="(search_Obj.f_is_deepen==1 || search_Obj.f_is_deepen==0)"></el-table-column>
                        <el-table-column prop="deep_real" label="实际孔深" v-if="(search_Obj.f_is_deepen==1 || search_Obj.f_is_deepen==0)"></el-table-column>
                        <el-table-column prop="deep_cha" label="加深量" v-if="(search_Obj.f_is_deepen==1 || search_Obj.f_is_deepen==0)"></el-table-column>
                        <!-- <el-table-column prop="remark" label="提示"></el-table-column> -->
                        <!-- <el-table-column prop="un_deal" label="未处置数量" sortable></el-table-column> -->
                        <el-table-column prop="report_err" label="异常报告数量"></el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="titleBoxwhr" v-if="list_model ==2 && search_type == 1">
                    <h3>
                        孔号：{{work_hole.hole_code}}
                    </h3>
                    <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                    <!-- <el-button type="primary" style="margin-left: 20px" @click="exportHole()">导出</el-button> -->
                </div>
                <div class="dataBox" v-if="list_model ==2 && search_type == 1">
                    <el-table :data="tableData1" v-loading="loading" border stripe>
                        <!-- <el-table-column prop="hole_code" label="孔号"></el-table-column> -->
                        <el-table-column prop="segment_no" label="段号"></el-table-column>
                        <el-table-column prop="segment_length" label="灌浆长度"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume1" label="监测注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume_cha" label="差异值(L)"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量(kg)"></el-table-column>
                        <el-table-column prop="ash_volume1" label="监测注灰量(kg)"></el-table-column>
                        <el-table-column prop="ash_volume_cha" label="差异值(kg)"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate1" label="监测透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate_cha" label="差异值(Lu)"></el-table-column>
                        <el-table-column prop="pressure_cha_max" label="压力最大差值(Mpa)"></el-table-column>
                        <el-table-column prop="pressure_cha_min" label="压力最小差值(Mpa)"></el-table-column>
                        <el-table-column prop="density_cha_max" label="密度最大差值(g/cm3)"></el-table-column>
                        <el-table-column prop="density_cha_min" label="密度最小差值(g/cm3)"></el-table-column>
                        <el-table-column prop="remark1" label="提示"></el-table-column>
                        <el-table-column prop="result" label="处置结果">
                            <template slot-scope="scope" v-if="search_type==1">
                                <span>数据正常：{{scope.row.report_count_ok}}<br></span>
                                <span v-if="scope.row.report_count_err>0" style="color: #F56C6C">数据异常：{{scope.row.report_count_err}}<br></span>
                                <span v-else>数据异常：{{scope.row.report_count_err}}<br></span>
                                <!-- <span>数据丢失：{{scope.row.report_count_loss}}<br></span>
                                <span v-if="scope.row.report_count_no_deal>0" style="color: #F56C6C">数据未处置：{{scope.row.report_count_no_deal}}</span>
                                <span v-else>数据未处置：{{scope.row.report_count_no_deal}}</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope" v-if="search_type==1">
                                <el-button  size="mini" plain type="primary" @click="info1(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="dataBox" v-if="search_type == 2">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom" min-width="120"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="work_type_int" label="作业方式" sortable="custom" width="120">
                            <template slot-scope="scope" v-if="search_type == 2">
                                <span>{{ transEnu(scope.row.work_type_int, "work_type_int") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="begin_time" label="开始时间" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量" sortable="custom" width="100"></el-table-column>
                        <el-table-column prop="grout_volume2" label="监测注浆量" width="120"></el-table-column>
                        <el-table-column prop="grout_volume_cha2" label="注浆量差值" width="120"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量" sortable="custom" width="100"></el-table-column>
                        <el-table-column prop="ash_volume2" label="监测注灰量" width="120"></el-table-column>
                        <el-table-column prop="ash_volume_cha2" label="注灰量差值" width="120"></el-table-column>
                        <el-table-column prop="ash_volume_unit" label="单位注灰量" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="ash_volume_unit2" label="监测单位注灰量" width="140"></el-table-column>
                        <el-table-column prop="ash_volume_unit_cha2" label="单位注灰量差值" width="140"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率" sortable="custom" width="100"></el-table-column>
                        <el-table-column prop="permeable_rate2" label="监测透水率" width="120"></el-table-column>
                        <el-table-column prop="permeable_rate_cha2" label="透水率差值" width="120"></el-table-column>
                        <el-table-column prop="deal_result2" label="处置结果" width="120">
                            <template slot-scope="scope" v-if="search_type == 2 && scope.row.has_check==1">
                                <span>{{ transEnu(scope.row.deal_result2, "verify_result1") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope" v-if="search_type == 2">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox" v-if="list_model ==1 || search_type == 2">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
            </div>
        </el-card>
        <Info
            :hole_id="hole_id"
            :segment_no="segment_no"
            :report_type="search_Obj.report_type"
            title="监测数据验证分析详情"
            :to_report_id="to_report_id"
            :isshow="infoshow"
            @on-close="closeInfoDialog"
            @on-save-ok="verifyOk">
        </Info>
        <el-dialog title="选择时间区间" :visible.sync="export_show" width="500px">
            <el-radio-group v-model="export_time_type">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">按时间段</el-radio>
            </el-radio-group>
            <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="dateRangeSet"
                style="width:320px;margin-top: 20px"
                v-if="export_time_type==1">
            </el-date-picker>
            <div slot="footer" class="dialog-footer">
                <el-button @click="export_show = false">取 消</el-button>
                <el-button type="primary" @click="doExport">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import { verifyCheck, verifyExportUnit, verifyExportHole, exportVerifyExcel, exportVerifyReportPDFByUnit } from '@/api/statistic'
import Info from "./checkinfo"


export default {
    name: 'verify_check',
    mixins: [listutil],
    components: {Btns, LabBtns, Info},
    data() {
        return {
            m_name: '监测数据验证分析',
            menu_id: 7100,
            list_url: "/api/admin/verify/holeList",
            search_Obj: {
                f_grout_type: '',
                f_hole_code: '',
                is_error: '',
                report_type: 2,
                f_is_deepen: '',
                deal_result: '',
                f_segment_no: '',
                ash_volume_unit_max: '',
                ash_volume_unit_min: '',
                permeable_rate_max: '',
                permeable_rate_min: '',
            },
            del_Obj:{
                url:'/api/admin/workhole/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type', 'verify_result', 'yesNo', 'work_type_int', 'verify_result1'],
            grade: 0,
            pid: 0,
            pname: '',
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'un_deal',
                order: 'descending'
            },
            currentPage: 1,
            pageSize: 10,
            pagedData: [],
            export_show: false,
            export_type: 1,
            export_time_type: 0,
            dateRange: '',
            start_date: '',
            end_date: '',
            list_model: 1,
            hole_id: 0,
            segment_no: '',
            to_report_id: 0,
            tableData1: [],
            empty_text:'',
            work_hole: {},
            echarts_show: 0,
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    name:'',
                    type: 'value'
                },
                series: [
                    {
                        name: '',
                        type: 'bar',
                        data: []
                    }
                ]
            },
            option1: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: [{
                    name:'',
                    type: 'value'
                },{
                    name:'',
                    type: 'value'
                }],
                series: [
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: []
                    }
                ]
            },
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(151).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            this.tableData = []
            this.pagedData = []
            if(this.search_type == 1){
                this.list_url = "/api/admin/verify/holeList"
            }else if(this.search_type == 2){
                this.list_url = "/api/admin/verify/reportList"
            }
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                this.tableData = []
                if (res.code === 1) {
                    if(this.search_type == 1){
                        this.tableData = res.data.list;
                        this.tableData.sort((a, b) => {
                            let a1 = a[this.sortData.prop].toString()
                            let b1 = b[this.sortData.prop].toString()
                            return b1.localeCompare(a1);
                        });
                        this.handleCurrentChange(1)
                        this.total = res.data.list.length
                        this.grade = res.data.grade
                        this.pname = res.data.pname
                        this.pid = res.data.pid
                    }else{
                        this.tableData = res.data.resultList;
                        this.total = res.data.totalRecords
                        this.pid = res.data.pid
                    }
                    
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }else if(res.code == 990){
                    this.empty_text = res.msg
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    this.pname = res.data.pname
                    this.total = 0
                }
            })
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.pagedData = this.tableData.slice(startIndex, endIndex);
        },
        sortTable(column) {
            this.tableData.sort((a, b) => {
                if (column.order === 'ascending') {
                    let a1 = a[column.prop].toString()
                    let b1 = b[column.prop].toString()
                    return a1.localeCompare(b1);
                } else {
                    let a1 = a[column.prop].toString()
                    let b1 = b[column.prop].toString()
                    return b1.localeCompare(a1);
                }
            });
            this.handleCurrentChange(this.currentPage)
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.getListData()
            this.list_model = 1
        },
        info(index, row) {
            if(this.search_type == 1){
                this.list_model = 2
                this.hole_id = row.hole_id
                verifyCheck(row.hole_id, this.search_Obj.report_type, this.search_Obj.is_error).then(res=>{
                    if(res.code == 1){
                        this.tableData1 = res.data.list
                        this.work_hole = res.data.work_hole
                    }
                })
            }else if(this.search_type == 2){
                this.hole_id = row.hole_id
                this.segment_no = row.segment_no
                this.infoshow = true
                this.to_report_id = row.id
            }
        },
        info1(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.infoshow = true
        },
        verifyOk(){
            this.infoshow = false
            this.list_model = 2
            verifyCheck(this.hole_id, this.search_Obj.report_type, this.search_Obj.is_error).then(res=>{
                if(res.code == 1){
                    this.tableData1 = res.data.list
                    this.work_hole = res.data.work_hole
                }
            })
        },
        back(){
            this.list_model = 1
            this.tableData1 = []
            this.work_hole = {}
            this.getListData()
        },
        export(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            verifyExportUnit(this.search_Obj.report_type, this.pid, this.search_Obj.f_hole_code, this.search_Obj.is_error).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        exportExcel(){
            this.export_type = 1;
            this.export_show = true
        },
        exportPDF(){
            this.export_type = 2;
            this.export_show = true
        },
        doExport(){
            if(this.export_time_type == 0){
                this.start_date = ''
                this.end_date = ''
            }else if(this.export_time_type == 1 && (this.start_date == '' || this.end_date == '')){
                this.$msg("请先选择时间区间")
                return
            }
            if(this.export_type ==1){
                this.export_show = false
                const loading = this.$loading({
                    lock: true,
                    text: '正在执行...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                exportVerifyExcel(this.pid, this.grade, this.search_Obj.report_type, this.start_date, this.end_date).then(res=>{
                    loading.close()
                    if(res.code == 1){
                        window.open(res.data)
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }else{
                if(this.grade !=4){
                    this.$msg("请选择左侧单元")
                    return
                }
                let confirm_msg = "确定要批量导出单元【"+this.pname+"】下的PDF数据吗？"
                this.$confirm(confirm_msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.export_show = false
                    const loading = this.$loading({
                        lock: true,
                        text: '正在导出，该过程用时较长，请耐心等待...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    exportVerifyReportPDFByUnit(this.pid, this.search_Obj.report_type, this.start_date, this.end_date).then(res=>{
                        loading.close()
                        if(res.code == 1){
                            window.open(res.data)
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                }).catch(() => { })
            }
        },
        exportHole(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            verifyExportHole(this.search_Obj.report_type, this.hole_id).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.start_date = val[0]
                this.end_date = val[1]
            }else{
                this.start_date = ''
                this.end_date = ''
            }
        },
        changeSearchType(type){
            this.search_type = type
            this.list_model = 1
            this.tableData1 = []
            this.work_hole = {}
            this.doSearch()
        },
        dateRangeSet1(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_begin_time_s_date = val[0]
                this.search_Obj.f_begin_time_e_date = val[1]
            }else{
                this.search_Obj.f_begin_time_s_date = ''
                this.search_Obj.f_begin_time_e_date = ''
            }
        },
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
</style>